import React from 'react';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import {
  ContentWrapper,
  ImageContainer,
  TextContainer,
  StreamIconsWrapper,
  StreamGroup,
} from './style';
import helpCircle from '../../../../images/help-circle.svg';
import { STREAMS } from '../../../common/variables';

const Wrapper = styled.div`
  .hidden-products {
    display: none;
  }

  .heading-text {
    margin-bottom: 35px;
    color: #69ad3f;
    font-weight: 400;
    font-size: 2rem;

    i {
      color: #666985;
    }
  }
`;

class MultiStreamsSlider extends React.Component {
  state = { streamIndex: 0, failedIcons: [], maxHeight: null };
  componentDidMount() {
    this.setState({ maxHeight: this.textEl.clientHeight });
    // Every 3 seconds, try to show the next image
    // If theres no more images, reset back to the first
    this.timeOut = setTimeout(() => {
      this.interval = setInterval(() => {
        if (
          !this.props.streamChoices[this.state.streamIndex + 1] ||
          this.state.streamIndex === 8
        ) {
          this.setState({ streamIndex: 0 });
          return;
        }
        this.setState({ streamIndex: this.state.streamIndex + 1 });
      }, 3000);
    }, 3000);
  }

  // generateImageLinks = () => {
  //   return this.props.streamChoices
  //     .filter((s) => s.fluid)
  //     .map((s) => s.fluid.src);
  // };

  componentWillUnmount() {
    clearInterval(this.interval);
    clearTimeout(this.timeOut);
  }

  handleStreamClick = (event) => {
    if (event.target.dataset.index) {
      clearInterval(this.interval);
      this.setState({
        streamIndex: parseInt(event.target.dataset.index),
      });
    } else {
      console.error('[Alert] Invalid Event Target Clicked', event.target);
    }
  };

  orderNRenderIcons = (streams_group) => {
    const orderedStreams = streams_group.sort((a, b) => a.term_id - b.term_id);
    return orderedStreams
      .filter((stream) => {
        if (STREAMS.find((s) => s.slug === stream.slug)) {
          return !STREAMS.find((s) => s.slug === stream.slug).hidden;
        } else {
          return true;
        }
      })
      .map((stream) => {
        return <SVG key={stream.slug} src={stream.iconURL || helpCircle} />;
      });
  };

  setRef = (element) => {
    if (!this.textEl) this.textEl = element;
  };

  render() {
    const { streamChoices } = this.props;
    const { streamIndex } = this.state;

    if (
      !streamChoices ||
      streamChoices.length === 0 ||
      !streamChoices[streamIndex]
    )
      return null;

    const orderedStreamG = streamChoices[streamIndex].streams_group.sort(
      (a, b) => a.term_id - b.term_id
    );

    return (
      <Wrapper>
        {/* <div className="hidden-products">
          {this.generateImageLinks().map((link, index) => (
            <img
              aria-hidden="true"
              alt="Hidden Products"
              key={index}
              src={link}
            />
          ))}
        </div> */}
        <h2 className="heading-text">
          Which <i>Recycling Streams</i> should you choose?
        </h2>
        <ContentWrapper>
          <ImageContainer>
            <img
              alt={streamChoices[streamIndex].name}
              key={streamChoices[streamIndex].name}
              src={streamChoices[streamIndex].fluid || helpCircle}
            />
          </ImageContainer>
          <TextContainer>
            <h3>
              {orderedStreamG.map((stream, i) =>
                orderedStreamG.length === i + 1
                  ? stream.name
                  : stream.name + ', '
              )}
            </h3>
            <StreamIconsWrapper>
              {streamChoices.map((streamChoice, index) => (
                <StreamGroup
                  key={index}
                  data-index={index}
                  onClick={this.handleStreamClick}
                  className={streamIndex === index ? '' : 'inactive'}
                >
                  {this.orderNRenderIcons(streamChoice.streams_group)}
                </StreamGroup>
              ))}
            </StreamIconsWrapper>
            <div
              className="stream-description"
              ref={this.setRef}
              style={{
                minHeight: this.state.maxHeight || 500,
                maxHeight: this.state.maxHeight || 500,
              }}
              dangerouslySetInnerHTML={{
                __html: streamChoices[streamIndex].desc,
              }}
            />
          </TextContainer>
        </ContentWrapper>
      </Wrapper>
    );
  }
}

export default MultiStreamsSlider;
